<footer class="footer">
<!--    <div id="social-share">-->
<!--        <nav>-->
<!--            <a href="https://www.facebook.com/agaia.life" target="_blank" class="facebook">-->
<!--                <i class="fa fa-facebook-square"></i><span class="hide-on-mobile">Facebook</span>-->
<!--            </a>-->
<!--            <a href="https://www.instagram.com/agaia.life" target="_blank" class="instagram">-->
<!--                <i class="fa fa-instagram"></i><span class="hide-on-mobile">Instagram</span>-->
<!--            </a>-->
<!--            <a (click)="copyUrl()" class="copy"><i class="fa fa-link"></i><span class="hide-on-mobile">Copy URL</span></a>-->
<!--        </nav>-->
<!--    </div>-->

    <div id="terms">
        <div style="text-align: center;margin-bottom: 15px;">
            <a href="https://apps.apple.com/app/agaia-life/id1589104436" target="_blank">
                <img src="assets/images/apps/ios.svg" height="42" style="margin-right: 8px;"/>
            </a>

            <a href="https://play.google.com/store/apps/details?id=life.agaia.app" target="_blank">
                <img src="assets/images/apps/play-store-2.png" height="42"/>
            </a>

        </div>

        <ul>
            <li>© 2020 Agaia</li>
            <li><a routerLink="/misc/terms">{{ 'terms' | localise }}</a></li>
            <li><a routerLink="/misc/contacts">{{ 'contact_us' | localise }}</a></li>
        </ul>
    </div>
</footer>
